import type { SocialLink, StoreSupportContact } from '@/api/endpoints'

const RESTRICTED_HOST_MARKERS = [
  'instagram.com',
  'instagr.am',
  'facebook.com',
  'fb.com',
  'fb.me',
  'm.facebook.com',
]

const RESTRICTED_TITLE_MARKERS = [
  'instagram',
  'инстаграм',
  'инста',
  'facebook',
  'фейсбук',
  'meta',
]

function normalizeUrlHost(link: string): string {
  try {
    return new URL(link).hostname.toLowerCase()
  } catch {
    return ''
  }
}

function includesRestrictedMarker(value: string): boolean {
  const lowered = value.toLowerCase()
  return RESTRICTED_TITLE_MARKERS.some((marker) => lowered.includes(marker))
}

export function isRestrictedSocialLink(social: Pick<SocialLink, 'title' | 'link'>): boolean {
  const host = normalizeUrlHost(social.link)

  if (host && RESTRICTED_HOST_MARKERS.some((marker) => host === marker || host.endsWith(`.${marker}`))) {
    return true
  }

  return includesRestrictedMarker(social.title)
}

export function isRestrictedSupportContact(contact: Pick<StoreSupportContact, 'contact_type' | 'name' | 'value' | 'url'>): boolean {
  if (contact.contact_type === 'instagram') {
    return true
  }

  if (contact.url && isRestrictedSocialLink({ title: contact.name, link: contact.url })) {
    return true
  }

  return includesRestrictedMarker(contact.name) || includesRestrictedMarker(contact.value)
}
